import { GetDeleteElementOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getDeleteElementTag = (options: GetDeleteElementOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const deleteElementModalEvent = [
    {
      eventInfo: {
        eventName: 'area',
        eventAction: options.elementPosition,
      },
    },
    {
      eventInfo: {
        eventName: options.elementType,
        eventAction: 'delete',
      },
    },
  ];

  const { modal, user } = getModalTag(options.productType, 'Edit Mode', deleteElementModalEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
